import { useRecoilValue } from 'recoil';

import { screenMessageState } from '../../atoms';
import { ScreenMessageSeverity } from '../../types';
import { defined } from '../../utils/defined';
import { Alert } from '../Alert';

const SEVERITY_COLORS: Record<ScreenMessageSeverity, string> = {
	ERROR: 'danger',
	INFO: 'dark',
	SUCCESS: 'success'
};

export const ScreenMessage: React.FC = () => {
	const screenMessage = useRecoilValue(screenMessageState);

	return (
		<Alert
			type="controlled"
			color={SEVERITY_COLORS[screenMessage?.severity ?? 'ERROR']}
			isOpen={defined(screenMessage)}
			screenMessage={screenMessage?.message}
		/>
	);
};
